import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserSingleNeutralFilledSvg = function UserSingleNeutralFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.018 3.898a5.631 5.631 0 1 1 7.964 7.964 5.631 5.631 0 0 1-7.964-7.964M2.407 17.29A20.1 20.1 0 0 1 12 14.87c3.35-.005 6.647.827 9.593 2.42l.407.22v4.739H2V17.51z"
  }));
};
export var UserSingleNeutralFilled = function UserSingleNeutralFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserSingleNeutralFilledSvg
  }));
};